import React from 'react';
import {
  Button,
  Modal,
} from 'gatorcomponents';
import BrandByMonarx from '@/components/GatorProtect/BrandByMonarx/BrandByMonarx';
import useLocale from '@/hooks/useLocale';
import * as Styles from './GatorProtectAutomatedSecurityVideo.styles';
import type {
  GatorProtectAutomatedSecurityVideoLocale,
  GatorProtectAutomatedSecurityVideoProps,
} from './GatorProtectAutomatedSecurityVideo.types';

const videoPlayed = false;
const GatorProtectAutomatedSecurityVideo = ({
  onClose,
  onPrimary,
  onSecondary,
}: GatorProtectAutomatedSecurityVideoProps): React.ReactElement | null => {
  const { gatorProtect: gatorProtectLocale } = useLocale() as GatorProtectAutomatedSecurityVideoLocale;

  if (!gatorProtectLocale?.automatedSecurityVideo) {
    return null;
  }

  const { automatedSecurityVideo: automatedSecurityVideoLocale } = gatorProtectLocale;

  if (videoPlayed) {
    return null;
  }

  return (
    <Modal
      onClose={onClose}
      maxWidth={960}
      maxHeight={900}
      mobileMaxHeight={621}
      noHeader
      testId="gator-protect-automated-security-video-modal"
    >
      <Styles.Root data-testid="gator-protect-automated-security-video-modal__content">
        <Styles.BrandByMonarxWrapper>
          <BrandByMonarx
            isMobile={false}
            shieldVariant="yellow"
            variant="light"
            showProBadge
            darkBadge
          />
        </Styles.BrandByMonarxWrapper>

        <Styles.Headline>
          {automatedSecurityVideoLocale.title}
        </Styles.Headline>

        <Styles.FeaturesBlock>
          <iframe
            width="900px"
            height="500px"
            data-testid="gator-protect-automated-security-video"
            src="https://www.youtube.com/embed/eLnZRRNxLFE?autoplay=1&controls=0&rel=0&modestbranding=1&cc_load_policy=0&iv_load_policy=3"
            title="Gator Protect: Segurança de Site Automatizada"
            frameBorder="0"
            allow="autoplay"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        </Styles.FeaturesBlock>

        <Styles.PrimaryButtonWrap>
          <Button
            width="fit"
            label={automatedSecurityVideoLocale.secondaryCta}
            onClick={onSecondary}
            size="large"
            variant="tertiary"
            notFillSVG
          />
          <Button
            width="fit"
            label={automatedSecurityVideoLocale.primaryCta}
            onClick={onPrimary}
            size="large"
            variant="primary"
            notFillSVG
          />
        </Styles.PrimaryButtonWrap>
      </Styles.Root>
    </Modal>
  );
};

export default GatorProtectAutomatedSecurityVideo;
